import { httpClient } from '../httpClient';
import { partnerService } from '../../services/helperServices/PartnerService';
import { translationUrl } from '../endpoints';
import { defaultTranslation } from './translation';

const applicationId = process.env.REACT_APP_ENV === 'production' ? 13 : 13;

class TranslationService {

  _once = false;

  getTranslation() {
    return httpClient.get(translationUrl(), {
      params: {
        code: partnerService.language,
      },
      headers: {
        ApplicationId: applicationId,
      },
    }).then((data) => {
      this._once = true;
      if (data) {
        return {
          ...defaultTranslation,
          ...data,
        };
      }
      return defaultTranslation;
    });
  }
}

export const translationService = new TranslationService();
